module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Datepicker 日期选择")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('datepicker', {
    attrs: {
      "moment": _vm.moment
    },
    on: {
      "update:moment": function($event) {
        _vm.moment = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--直接使用datepicker标签, datepicker的宽度由外层容器的宽度决定(占满)-->\n<div style=\"width: 200px;\">\n<datepicker :moment.sync=\"moment\"></datepicker>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v(" data() {\n  return {\n    // 为了解决js在计算时间时跟后端算法不同，采用了毫秒计数\n    moment: new Date().getTime()\n  }\n}\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("moment")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("默认时间(为了配合双向绑定，改为必填项)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1004723a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/datepicker-demo.vue
// module id = 384
// module chunks = 1